import { SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { BREAKPOINTS } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const StepsSectionContainer = styled.div`
  padding: 80px 150px;

  @media ${BREAKPOINTS.md} {
    padding: 70px 0px;
  }

  @media ${BREAKPOINTS.sm} {
    padding: 70px 0px;
  }
`;

export const StepsSectionTitle = styled.h1`
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontSemiBold}
  padding: 70px 10px;
  ${FONTS.font20}

  @media ${BREAKPOINTS.xl} {
    ${FONTS.font20};
  }

  @media ${BREAKPOINTS.md} {
    ${FONTS.font16};
  }

  @media ${BREAKPOINTS.sm} {
    padding-left: 30px;
    ${FONTS.font14};
    width: unset;
  }
`;
export const StepWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 100%;

  @media ${BREAKPOINTS.lg} {
    ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  }
`;

export const StepsTitleWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  width: 100%;

  @media ${BREAKPOINTS.lg} {
    width: 100%;
    text-align: center;
    ${FLEX_CONTAINER.FlexColumn}
    flex-direction: column-reverse;
  }

  @media ${BREAKPOINTS.md} {
    width: unset;
  }
`;

export const StepImage = styled.img`
  @media ${BREAKPOINTS.sm} {
    width: 170px;
    height: 190px;
  }
  @media ${BREAKPOINTS.md} {
    width: 240px;
    height: 280px;
  }
  @media ${BREAKPOINTS.xl} {
    width: 240px;
    height: 280px;
  }
`;

export const StepCount = styled.p`
  width: 80px;
  display: none;
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  color: ${COLORS.mainColor};

  @media ${BREAKPOINTS.sm} {
    margin-bottom: 32px;
    ${FONTS.font14}
  }
  @media ${BREAKPOINTS.md} {
    margin-bottom: 24px;
    ${FONTS.font16}
  }
  @media ${BREAKPOINTS.lg} {
    display: block;
    margin-bottom: 30px;
    ${FONTS.font16}
  }
`;

export const StepsContainer = styled.div`
  width: 380px;

}
  @media ${BREAKPOINTS.md} {
    width: max-content;
  }
`;

export const StepsTitle = styled.p`
  ${FONT_FAMILY.FontSemiBold};
  ${FONTS.font24};
  color: ${COLORS.mainColor};
  margin-bottom: 16px;

  @media ${BREAKPOINTS.sm} {
    text-align: center;
    ${FONTS.font16}
    margin-top:24px;
    margin-left: 14px;
  }

  @media ${BREAKPOINTS.md} {
    text-align: center;
    ${FONTS.font16};
    margin-top: 30px;
    margin-left: 16px;
  }
`;
export const StepsSubTitle = styled.p`
  width: 382px;
  color: ${COLORS.mainColor};
  padding-bottom: 64px;
  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14}
  }
  @media ${BREAKPOINTS.lg} {
    ${FONTS.font16}
  }

  @media ${BREAKPOINTS.md} {
    width: 280px;
  }
`;
export const MobileSteps = styled.div`
  @media (min-width: ${SIZE.mobile}) {
    ${FLEX_CONTAINER.FlexColumn}
    flex-direction: column-reverse;
    width: 100%;
    display: none;
  }

  @media ${BREAKPOINTS.lg} {
    display: flex;
  }
`;

export const DesctopSteps = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  @media ${BREAKPOINTS.lg} {
    display: none;
  }
`;

export const PlanningSteps = styled.img`
  position: absolute;
  width: 116px;
  height: 834px;
  left: 50%;
  @media ${BREAKPOINTS.xl} {
    width: 90px;
    height: 650px;
    left: 45%;
  }
`;

export const LeftStepsImg = styled.img`
  @media ${BREAKPOINTS.sm} {
    width: 170px;
    height: 190px;
  }
  @media ${BREAKPOINTS.lg} {
    width: 240px;
    height: 280px;
  }
  @media ${BREAKPOINTS.xl} {
    width: 240px;
    height: 280px;
  }
`;
export const StepsYourTrips = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  margin-bottom: 40px;
`;
export const HowItsWorkPage = styled.div`
  min-height: 100%;
  min-width: 100%;
  background: linear-gradient(
    180deg,
    #fafeff 0%,
    #a8c9e1 54.82%,
    #ecf1f1 84.37%,
    #ecf1f1 96.81%,
    #ecf1f1 100%
  );
`;
